import React, { Fragment, useState, useEffect, useContext } from "react";
import GoBackBtn from "../../../components/buttons/GoBackBtn";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../App";
import { postMethod } from "../../../requests";
import PassCard from "../../../components/passes/PassCard";
import RegisterPaymentForm from "../../../components/forms/RegisterPaymentForm";
import { validatePrice } from "../../../commonData";
import $ from "jquery";

const AddPassToUser = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const { showView, checkServerData, setAlerts, changeView } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [selectedPass, setSelectedPass] = useState(null);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [payment, setPayment] = useState(null);
    const [privillege, setPrivillege] = useState(null);

    const getPassesList = async () => {
        const res = await postMethod("/passes-list", { onlyActivePasses: true });
        if (checkServerData(res)) {
            setPrivillege(res.data.purchasePassPriv);
            setList(res.data.list);
        }
        setLoading(false);
    };

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        //if (!selectedPass) errors.push(t("error.noCheckedPass"));
        if (payment) {
            if (!validatePrice(payment.payment_amount) || payment.payment_amount.length === 0 || !payment.payment_amount.replace(/\s+/, "")) {
                $("#paymentAmount").addClass("is-invalid");
                errors.push(t("error.invalidPaymentAmount"));
            }
            if (payment.payment_comment && (payment.payment_comment.length === 0 || !payment.payment_comment.replace(/\s+/, ""))) {
                $("#paymentComment").addClass("is-invalid");
                errors.push(t("error.invalidPaymentComment"));
            } else if (payment.payment_comment && payment.payment_comment.length > 255) {
                $("#paymentComment").addClass("is-invalid");
                errors.push(t("error.paymentCommentTooLong"));
            }
            if (!payment.paymentMethod) {
                $(`#paymentType`).addClass("is-invalid");
                errors.push(t("error.noCheckedPaymentMethod"));
            }
            if (!payment.payment_date) {
                $(`#paymentDate`).addClass("is-invalid");
                errors.push(t("error.noPaymentDate"));
            }
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e, i) => {
                list.push({ variant: "danger", message: e, id: i });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t(`info.assigningPass`) }]);
            setBlockForm(true);
            assignPassAndDoPayment();
        }
    };

    const assignPassAndDoPayment = async () => {
        const res = await postMethod("/add-pass-to-user", { userID: showView.params.userID, payment: payment, pass: selectedPass });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "assignPassAndDoPayment" }]);
            changeView({ nav: "users", sub: "userDetails", params: { userID: showView.params.userID, tabName: "passes" } });
        } else setBlockForm(false);
    };

    useEffect(() => {
        if (payment) setPayment({ ...payment, payment_amount: selectedPass.pass_price.toString() });
        // eslint-disable-next-line
    }, [selectedPass]);

    useEffect(() => {
        getPassesList();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <GoBackBtn />
            <Container fluid="lg" id="addPassToUser">
                <Row>
                    <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                        <h1 className="h4 d-inline-block m-0 pt-2">{t(`passes.addPassToUser`)}</h1>
                    </Col>
                    {loading ? (
                        <Col xs={12} className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    ) : (
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <Form onSubmit={checkValidation} autoComplete="off">
                                <Row>
                                    {list.length > 0 ? (
                                        <Fragment>
                                            {list.map((e, i) => (
                                                <Col xs={12} lg={6} xl={4} xxl={3} className="" key={i}>
                                                    <PassCard
                                                        pass={e}
                                                        i={i}
                                                        allowedPermission={privillege}
                                                        onProceed={() => {
                                                            setSelectedPass(e);
                                                            setFormChanged(true);
                                                            $("html, body").animate(
                                                                {
                                                                    scrollTop: $("#paymentBtn").offset().top,
                                                                },
                                                                200
                                                            );
                                                        }}
                                                    />
                                                </Col>
                                            ))}
                                        </Fragment>
                                    ) : (
                                        <Col xs={12} className="text-center">
                                            <p className="fs-5">{t("notFound")}</p>
                                        </Col>
                                    )}
                                </Row>
                                <Row id="paymentBtn">
                                    {!payment ? (
                                        <Col xs={12} className="my-3">
                                            <Button
                                                disabled={!selectedPass}
                                                className="my-3"
                                                variant="primary"
                                                onClick={() =>
                                                    setPayment({
                                                        paymentMethod: null,
                                                        payment_amount: selectedPass.pass_price.toString(),
                                                        payment_date: new Date(),
                                                        payment_comment: "",
                                                    })
                                                }
                                            >
                                                <FontAwesomeIcon icon={faPlus} className="me-2" />
                                                {t("payments.addPayment")}
                                            </Button>
                                        </Col>
                                    ) : (
                                        payment &&
                                        selectedPass && (
                                            <Col xs={12} className="my-3">
                                                <Button disabled={!selectedPass} variant="outline-primary" onClick={() => setPayment(null)}>
                                                    <FontAwesomeIcon icon={faBan} className="me-2" />
                                                    {t("payments.removePayment")}
                                                </Button>
                                            </Col>
                                        )
                                    )}
                                    {payment && (
                                        <Col xs={12} lg={6}>
                                            <RegisterPaymentForm payment={payment} setPayment={setPayment} setFormChanged={setFormChanged} blockForm={blockForm} />
                                        </Col>
                                    )}
                                </Row>
                                <Row className="bg-light-primary" style={{ zIndex: 1 }}>
                                    <Col xs={12} className="my-4">
                                        <Row>
                                            <Col xs={7} lg={6}>
                                                <Button variant="primary" type="submit" disabled={blockForm || !formChanged}>
                                                    {t(`assign`)}
                                                </Button>
                                            </Col>
                                            <Col xs={5} lg={6} className="text-end">
                                                <Button
                                                    variant="outline-secondary"
                                                    onClick={() => changeView({ nav: "users", sub: "userDetails", params: { userID: showView.params.userID } })}
                                                >
                                                    {t("cancel")}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    )}
                </Row>
            </Container>
        </Fragment>
    );
};

export default AddPassToUser;
